import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PdfreportLoaderService {
  pdfreportLoader = new BehaviorSubject<boolean>(false);

  get pdfreportLoader$(): Observable<boolean> {
    return this.pdfreportLoader.asObservable();
  }

  setPdfReportLoader(value: boolean): void {
    this.pdfreportLoader.next(value);
  }
}
